/** @flow */

import { cloneObject } from "@utils/object";
import {
  GetAppAdoptionHighlights,
  GetAppAdoptionHighlightsSuccess,
  GetAppAdoptionHighlightsError,
  GetAppAdoptionDepartments,
  GetAppAdoptionDepartmentsSuccess,
  GetAppAdoptionDepartmentsError,
  ExportAppAdoptionDepartments,
  ExportAppAdoptionDepartmentsSuccess,
  ExportAppAdoptionDepartmentsError,
} from "@modules/service/constants/actions";
import * as appAdoptionReduces from "./reducers";

import initialState from "./state";

import type { AppAdoptionState } from "./types";

export default (state: AppAdoptionState = initialState, action: Object): AppAdoptionState => {
  const act = {
    // Highlights
    [GetAppAdoptionHighlights]: appAdoptionReduces.onGetAppAdoptionHighlights,
    [GetAppAdoptionHighlightsSuccess]: appAdoptionReduces.onGetAppAdoptionHighlightsSuccess,
    [GetAppAdoptionHighlightsError]: appAdoptionReduces.onGetAppAdoptionHighlightsError,

    // Department Results
    [GetAppAdoptionDepartments]: appAdoptionReduces.onGetAppAdoptionDepartments,
    [GetAppAdoptionDepartmentsSuccess]: appAdoptionReduces.onGetAppAdoptionDepartmentsSuccess,
    [GetAppAdoptionDepartmentsError]: appAdoptionReduces.onGetAppAdoptionDepartmentsError,

    // Department exports
    [ExportAppAdoptionDepartments]: appAdoptionReduces.onExportAppAdoptionDepartments,
    [ExportAppAdoptionDepartmentsSuccess]: appAdoptionReduces.onExportAppAdoptionDepartmentsSuccess,
    [ExportAppAdoptionDepartmentsError]: appAdoptionReduces.onExportAppAdoptionDepartmentsError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
